/**
 * @generated SignedSource<<923c50e54071a1f1a9064b98c5691e81>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProductDetailsSection$data = {
  readonly __typename: "ProductInfoSection";
  readonly label: string | null;
  readonly rows: ReadonlyArray<{
    readonly " $fragmentSpreads": FragmentRefs<"ProductDetailsRow">;
  } | null> | null;
  readonly " $fragmentType": "ProductDetailsSection";
};
export type ProductDetailsSection$key = {
  readonly " $data"?: ProductDetailsSection$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProductDetailsSection">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProductDetailsSection",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "label",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "rows",
      "plural": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ProductDetailsRow"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    }
  ],
  "type": "ProductInfoSection",
  "abstractKey": null
};

(node as any).hash = "c2668a8af3e1186c6b41e320bd81a991";

export default node;
